export default {
  // API_URL: 'http://192.168.10.66:2061'
  API_URL: process.env.NODE_ENV === 'production' ? '' : 'http://192.168.205.150:2066'
}



// WEBPACK FOOTER //
// ./src/config.js